import { PLOT_TYPE } from "./indicatorTypes";

// An array per drawn plot (a background is drawn from other plots) and per helper buffer
const createSeries = (definition) => {
  const keys = definition.plots
    .filter((plot) => plot.type !== PLOT_TYPE.FILL)
    .map((plot) => plot.key)
    .concat(definition.buffers || []);

  return Object.fromEntries(keys.map((key) => [key, []]));
};

/**
 * Full calculation: every value of the indicator for `bars` (a new
 * history, older bars on the left, other inputs).
 *
 * @param {object} definition - from the registry, with `calculate`
 * @param {object[]} bars - oldest first
 * @param {object} inputs - normalizeInputs
 * @param {{ priceStep: number }} context - the price step of the pair (ZigZag deviation in points)
 * @returns {Object<string, number[]>} values per plot key, NaN where there is none
 */
export const calculateAll = (definition, bars, inputs, context) => {
  const series = createSeries(definition);

  definition.calculate(bars, inputs, series, 0, context);

  return series;
};

/**
 * Incremental calculation: values from `fromIndex` on, the earlier ones
 * stay (a tick: the last bar; a new bar: the previous last bar and the new one).
 *
 * @param {object} definition
 * @param {object[]} bars - the bars of the last calculation, the tail changed or added
 * @param {object} inputs
 * @param {Object<string, number[]>} series - from calculateAll, changed in place
 * @param {number} fromIndex
 * @param {{ priceStep: number }} context - see calculateAll
 * @returns {number} the first index whose value may have changed (a calculation may go back, e.g. ZigZag)
 */
export const recalculateFrom = (definition, bars, inputs, series, fromIndex, context) => {
  const firstChanged = definition.calculate(bars, inputs, series, fromIndex, context);

  return Number.isInteger(firstChanged) ? Math.max(0, Math.min(firstChanged, fromIndex)) : fromIndex;
};
